export const blockIconsDevicePassword = (
	<span className='material-symbols-outlined'>password</span>
);
